<script setup lang="ts">
const options = ["+1", "0", "-1"];

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    id?: string;
  }>(),
  {
    modelValue: "0",
    id: undefined,
  },
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const data = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});
</script>

<template>
  <FormSelect
    :options="options"
    v-model="data"
    :label="$t('S.LIT_Octave')"
    :id="id"
    small
    class="hidden xl:block"
  />
  <ToolbarButtonDropdown
    :label="$t('S.LIT_Octave')"
    icon="fa-ccli-octave-shift-3 fa-kit"
    class="xl:hidden"
  >
    <ToolbarButtonDropdownHeader>{{
      $t("S.LIT_Octave")
    }}</ToolbarButtonDropdownHeader>
    <ToolbarButtonDropdownItem
      v-for="o of options"
      @click="data = o"
      :key="o"
      >{{ o }}</ToolbarButtonDropdownItem
    >
  </ToolbarButtonDropdown>
</template>

<style scoped lang="postcss"></style>
